module.exports = __webpack_public_path__ + "img/pain.0d1ed36f.jpg";